import { render, staticRenderFns } from "./SortTable.vue?vue&type=template&id=412dc676"
import script from "./SortTable.vue?vue&type=script&lang=js"
export * from "./SortTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports